import React, { Component } from 'react';
import { Dialog } from "primereact/dialog";
import { Button } from 'primereact/button';
import './printConversation.css'
import moment from "moment";
import ReactToPrint from "react-to-print";
import { emptyObject } from '../../controller/utils';


export default class PrintConversationData extends Component {


    renderModal(open, body, onHide, headerTitle, id, footer) {
        return (
            <Dialog
                header={headerTitle}
                visible={open}
                modal
                closeOnEscape
                id={id}
                onHide={onHide}
                style={{ width: "50vw" }}
                footer={footer}

            >
                {body}
            </Dialog>
        );
    }

    renderPlantillaHtml(datos) {
        console.log(datos);
        const principal = datos.info.stepPrincipal.afiliacionEmpresas;
        const inicio = datos.info.step0.datosinicio;
        const contacto = datos.info.step1.datospersonaladmin ? datos.info.step1.datospersonaladmin : [];
        const empleador = datos.info.step2.datosempleador ? datos.info.step2.datosempleador : {};
        const caja = datos.info.step2.ubicacionempleadorask ? datos.info.step2.ubicacionempleadorask : {};
        const ubicacion = datos.info.step3.ubicacionempleador ? datos.info.step3.ubicacionempleador : {};
        const ubicacionContact = datos.info.step3.ubicacionempleadorcontact ? datos.info.step3.ubicacionempleadorcontact : {};
        const ubicacionAlt = datos.info.step3.ubicacionempleadoraltern ? datos.info.step3.ubicacionempleadoraltern : {};
        const representante = datos.info.step4.datosrepresentante ? datos.info.step4.datosrepresentante : {};
        const history = datos.history;
        const big = datos.big;
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        return (
            <div >
                {datos ? (
                    <div className="card" id="dataConversacion" >
                        <div className="p-grid" ref={(el) => (this.componentRef = el)}>
                            <div className="p-col-6">
                                <h3 className="title-h3">Información empleador</h3>
                                <h3><p>Razon social: </p>{inicio.employerNameStart}</h3>
                                <h3><p>Identificaciòn empleador: </p>{`${principal.typeIdCompanyGes} ${principal.numberIdCompanyGes}-${empleador.digitNumber}`}</h3>
                                <h3><p>Información de contacto: </p>{`${inicio.emailCompanyStart} ${emptyObject(ubicacionContact.phoneCompany)} ${ubicacionContact.smartPhoneCompany} ${emptyObject(ubicacionContact.webSite)}`}</h3>
                                <h3><p>Direcciòn: </p>{`${emptyObject(ubicacion.addressCompany)} ${emptyObject(ubicacion.hoodCompany)} ${emptyObject(ubicacion.cityCompany)} ${emptyObject(ubicacion.departamentCompany)}`}</h3>
                                <h3><p>Direcciòn alterna: </p>{`${emptyObject(ubicacion.addressCompanyAlternate)} ${emptyObject(ubicacion.hoodCompanyAlternate)} ${emptyObject(ubicacion.cityCompanyAlternate)} ${emptyObject(ubicacion.departamentCompanyAlternate)}`}</h3>

                            </div>

                            <div className="p-col-6">
                                <h3 className="title-h3">Información afiliación</h3>
                                <h3><p>Tipo de empleador: </p>{`${principal.empleadorTypeCompany} - ${emptyObject(principal.empleadorTypeCompanyName)}`}</h3>
                                <h3><p>N° de oportunidad: </p>{emptyObject(datos.info.idOportunidad)}</h3>
                                <h3><p>N° de afiliación: </p>{emptyObject(datos.info.idDocu)}</h3>
                                <h3><p>Estado: </p>{emptyObject(datos.info.state) - emptyObject(big.state)}</h3>
                                <h3><p>Sucursal: </p>{`${emptyObject(inicio.sedeRegional)} - ${emptyObject(inicio.sedeRegionalName)}`}</h3>
                                <h3><p>Generado por: </p>{datos.info.asistido && datos.info.asistido.asesor ? "Asistido" : "Cliente"}</h3>
                                <h3><p>Caja afiliacion: </p>{caja.empleadorCajaAsk === "1" ? caja.empleadorCajaRta : ""}</h3>
                                <h3><p>Nùmero de empleados: </p>{inicio.employedNumberStart}</h3>
                                <h3><p>Actividad econòmica: </p>{empleador.economicActivity}</h3>
                                <h3><p>Valor nòmina: </p>{empleador.payrollMonth}</h3>
                                <h3><p>Fecha de inicio de operaciòn: </p>{empleador.startOperation?.toDate().toLocaleDateString(undefined, options)}</h3>
                                <h3><p>Primer periodo de aportes: </p>{empleador.contributionPeriod?.toDate().toLocaleDateString(undefined, options)}</h3>
                            </div>
                            {representante.numberId &&
                                <div className="p-col-6">
                                    <h3 className="title-h3">Información representante legal</h3>
                                    <h3><p>Identificación: </p>{`${emptyObject(representante.typeId)} ${emptyObject(representante.numberId)}`}</h3>
                                    <h3><p>Nombre completo: </p>{`${emptyObject(representante.firstName)} ${emptyObject(representante.secondName)} ${emptyObject(representante.firstLastname)} ${emptyObject(representante.secondLastname)}`}</h3>
                                    <h3><p>Genero: </p>{emptyObject(representante.sexo)}</h3>
                                    <h3><p>Fecha de nacimiento: </p>{representante.birthDate?.toDate().toLocaleDateString(undefined, options)}</h3>
                                    <h3><p>Cargo: </p>{emptyObject(representante.jobBoss)}</h3>
                                    <h3><p>Información de contacto: </p>{`${emptyObject(representante.emailJobBoss)} ${emptyObject(representante.smartPhoneBoss)}`}</h3>
                                </div>
                            }

                            {contacto.length > 0 &&

                                <div className="p-col-6">
                                    <h3 className="title-h3">Información personal administrativo</h3>
                                    {contacto.map((e) => (
                                        <div className="personal-admin p-col-6">
                                            <h3><p>Identificación: </p>{`${emptyObject(e.typeIdStaff)} ${emptyObject(e.numberIdStaff)}`}</h3>
                                            <h3><p>Nombre completo: </p>{`${emptyObject(e.firstNameStaff)} ${emptyObject(e.secondNameStaff)} ${emptyObject(e.firstLastnameStaff)} ${emptyObject(e.secondLastnameStaff)}`}</h3>
                                            <h3><p>Genero: </p>{emptyObject(e.sexoStaff)}</h3>
                                            <h3><p>Fecha de nacimiento: </p>{e.birthDateStaff?.toDate().toLocaleDateString(undefined, options)}</h3>
                                            <h3><p>Cargo: </p>{emptyObject(e.jobBossStaff)}</h3>
                                            <h3><p>Información de contacto: </p>{`${emptyObject(e.emailJobBossStaff)} ${emptyObject(e.smartPhoneBossStaff)}`}</h3>
                                        </div>
                                    ))}
                                </div>

                            }

                            <div className="p-col-6">
                                <h3 className="title-h3">Seguimiento Afiliación</h3>

                                <div className="personal-admin p-col-6">
                                    {big.dateCreate ? <h3><p>Fecha creación: </p>{big.dateCreate}</h3> : ""}
                                    {big.dateModifica ? <h3><p>Fecha ultima modificación: </p>{big.dateModifica}</h3> : ""}
                                    {big.dateSend ? <h3><p>Fecha envio: </p>{big.dateSend}</h3> : ""}
                                    {big.dateReSend ? <h3><p>Fecha reenvio: </p>{big.dateReSend}</h3> : ""}
                                    {big.dateValidCmr ? <h3><p>Fecha valida comercial: </p>{big.dateValidCmr}</h3> : ""}
                                    {big.userValidCmr ? <h3><p>Usuario valida comercial: </p>{big.userValidCmr}</h3> : ""}
                                    {big.dateValidaRya ? <h3><p>Fecha valida RyA: </p>{big.dateValidaRya}</h3> : ""}
                                    {big.userValidaRya ? <h3><p>Usuario valida RyA: </p>{big.userValidaRya}</h3> : ""}
                                    {big.dateAfilia ? <h3><p>Fecha afiliación: </p>{big.dateAfilia}</h3> : ""}
                                    {big.userAfilia ? <h3><p>Usuario afiliación: </p>{big.userAfilia}</h3> : ""}
                                    {big.dateDevolCmr ? <h3><p>Fecha devol comercial: </p>{big.dateDevolCmr}</h3> : ""}
                                    {big.userDevolCmr ? <h3><p>Usuario devol comercial: </p>{big.userDevolCmr}</h3> : ""}
                                    {big.motivoDevolCmr ? <h3><p>Motivo devol comercial: </p>{big.motivoDevolCmr}</h3> : ""}
                                    {big.obsDevolCmr ? <h3><p>Observación devol comercial: </p>{big.obsDevolCmr}</h3> : ""}
                                    {big.dateDevolRya ? <h3><p>Fecha devol RyA: </p>{big.dateDevolRya}</h3> : ""}
                                    {big.userDevolRya ? <h3><p>Usuario devol RyA: </p>{big.userDevolRya}</h3> : ""}
                                    {big.motivoDevolRya ? <h3><p>Motivo devol RyA: </p>{big.motivoDevolRya}</h3> : ""}
                                    {big.obsDevolRya ? <h3><p>Observación devol RyA: </p>{big.obsDevolRya}</h3> : ""}
                                    {big.dateAnula ? <h3><p>Fecha anulación: </p>{big.dateAnula}</h3> : ""}
                                    {big.userAnula ? <h3><p>Usuario anulación: </p>{big.userAnula}</h3> : ""}
                                    {big.motivoAnula ? <h3><p>Motivo anulación: </p>{big.motivoAnula}</h3> : ""}
                                    {big.obsAnula ? <h3><p>Observación anulación: </p>{big.obsAnula}</h3> : ""}
                                </div>

                            </div>


                            {history.length > 0 && <div className="p-col-12" >
                                <div className="p-text-bold mediumFontSize">Historial</div>
                                {
                                    history.map((r) => (
                                        <div className="row-history">
                                            <h3><p>Fecha: </p>{r.date}</h3>
                                            <div>
                                                <h3><p>Realizado por: </p></h3>
                                                {r.tomado.includes("Empresa") || r.tomado.includes("Usuario") ?
                                                    <div className="p-col-6">
                                                        <h3>Empresa</h3>
                                                        {r.name ? <h3><p>Nombre: </p>{r.name}</h3> : ""}
                                                        {r.email ? <h3><p>Correo electrónico: </p>{r.email}</h3> : ""}
                                                    </div>
                                                    :
                                                    <div className="p-col-6">
                                                        <h3>{r.rol} </h3>
                                                        <h3><p>Nombre: </p>{r.name}</h3>
                                                        <h3><p>Correo electrónico: </p>{r.email}</h3>
                                                    </div>
                                                }
                                            </div>
                                            <div>
                                                <h3><p>Accion realizada: </p>{r.action}</h3>
                                                {r.motivo ? <h3><p>Motivo: </p>{r.motivo}</h3> : ""}
                                                {r.observation ? <h3><p>Observación: </p>{r.observation}</h3> : ""}
                                                {r.refFile ? <h3>
                                                    <p>Referencia del archivo: </p>
                                                    <button type="button" id="miBotonPdf" onClick={() => window.open(`${process.env.REACT_APP_URL_BUCKET_COMFENALCO_DELAGENTE}${r.refFile}`, "", "toolbar=no,status=no,menubar=no,location=center,scrollbars=no,resizable=no,height=500,width=657")}>Ver</button></h3> : ""}
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>}
                        </div>
                    </div>
                ) : null}
            </div>

        );
    }



    render() {
        const { datos, cerrarModalDescargarDatos } = this.props;


        const footer = (
            <div>
                <ReactToPrint
                    trigger={() => <Button label='Imprimir' className="p-button-primary p-button-sm p-mr-1" />}
                    content={() => this.componentRef}
                    documentTitle={"Pre-afiliación empresas"}
                    pageStyle={'padding'}

                />
            </div>
        );

        return (
            <div>
                {this.renderModal(true,
                    this.renderPlantillaHtml(
                        datos
                    ),
                    cerrarModalDescargarDatos,
                    "Datos de la afiliación",
                    "dataConversacion",
                    footer
                )}
            </div>
        );
    }

}